module.exports = __webpack_public_path__ + "static/img/active_vip_08.a320c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_08.jpg
// module id = Ytak
// module chunks = 0